<fui-page class="page" wbo-element-width>
    <fui-page-pane>
        <fui-page-header [description]="descriptionLabel" [hasToggle]="false"
                         [title]="initialised ? (title ? '\'' + title + '\'' : titleLabel) : ''">
            <ng-content select="wbo-search-form"></ng-content>
        </fui-page-header>
        <fui-page-body>
            <fui-page-main>
                <!-- OPTIONAL UTILITY HEADER -->
                <fui-page-utility *ngIf="utilityControls?.length || showEditActions || utilityPlaceholder">
                    <div class="utility">
                        <div class="utility-placeholder" *ngIf="((!utilityControls?.length && !showEditActions) || forceShowUtilityPlaceholder) && utilityPlaceholder">
                            {{utilityPlaceholder | translate}}
                        </div>
                        <!-- CUSTOM UTILITY CONTROLS -->
                        <div class="utility-controls-left">
                            <ng-content select="wbo-edit-page-utility-controls[slot=left]"></ng-content>
                        </div>
                        <!-- EDIT ACTIONS -->
                        <div class="utility-actions" *ngIf="showEditActions">
                            <fui-commands [title]="actionsTitle" [showPopupForSingleItems]="true">
                                <fui-command [title]="'wbo.common.button.clone'" (clicked$)="cloneAction()"
                                             *ngIf="showCloneAction"></fui-command>
                                <fui-command [title]="'wbo.common.button.export'" (clicked$)="exportEntity()"
                                             *ngIf="enableImportExport"></fui-command>
                                <fui-command [title]="'wbo.common.button.import'" (clicked$)="importEntity()"
                                             *ngIf="enableImportExport"></fui-command>
                                <fui-command *ngFor="let action of entityActions" [title]="action.title"
                                             (clicked$)="clickAction(action)"></fui-command>
                            </fui-commands>
                        </div>
                        <div class="utility-controls-right">
                            <ng-content select="wbo-edit-page-utility-controls[slot=right]"></ng-content>
                        </div>
                    </div>
                </fui-page-utility>
                <fui-page-subject [masked]="maskSubject" [scrolled]="scrollSubject">
                    <fui-formation>
                        <fui-formation-groups [formationType]="formationType">
                            <!-- MAIN PAGE CONTENT -->
                            <ng-content></ng-content>
                            <!-- LOCALISATION -->
                            <ng-container
                                *ngIf="entityModel.isEntityLocalisable() && !disableEntityLocalisation && initialised && (LOCALISATION | booleanConfig)">
                                <fui-formation-group-template *formationGroup="{
                                    title: 'wbo.localisation.formation',
                                    formationType: FUIFormationType.NON_COLLAPSIBLE
                                }">
                                    <wbo-edit-localisation [localisable]="entityModel.data.localisableContext"
                                                           (selectionChanged)="localisationChange()"
                                                           [readonly]="editMode === EditMode.VIEW || disableEntityLocalisation"></wbo-edit-localisation>
                                </fui-formation-group-template>
                            </ng-container>
                        </fui-formation-groups>
                    </fui-formation>
                </fui-page-subject>
            </fui-page-main>
            <!-- OPTIONAL SIDE PANEL -->
            <fui-page-side-panel *ngIf="sidePanel">
                <ng-content select="wbo-edit-page-side-panel"></ng-content>
            </fui-page-side-panel>
        </fui-page-body>
    </fui-page-pane>
    <fui-page-footer>
        <!-- CUSTOM FOOTER CONTROLS -->
        <ng-template #FUIPageFooterControls>
            <ng-content select="wbo-edit-page-footer-controls"></ng-content>
        </ng-template>
        <!-- FOOTER BUTTONS -->
        <ng-template #FUIPageFooterButtons>
            <wbo-footer-spinner [label]="'wbo.common.label.generatingReport'"
                                [processing]="reportGenerationService && (reportGenerationService.running$ | async)"></wbo-footer-spinner>
            <fui-buttons *ngIf="editMode != undefined"
                         [ngSwitch]="!overrideShowSaveButton && (editMode === EditMode.VIEW || disableAction || (entityModel.$readonlyChange | async))">
                <ng-container *ngSwitchDefault>
                    <wbo-cancel-button *ngIf="!hideCancelAction"
                                       (click)="cancel()"
                                       [title]="cancelButtonTitle"></wbo-cancel-button>
                    <wbo-secondary-button *ngIf="!isStackedPageMode && editMode === EditMode.ADD && !hideAddAnotherButton && !hideSaveAddAnotherAction && !addAnotherOnSave"
                                          (click)="saveAndAddAnother()"
                                          [title]="'wbo.common.button.addAnother'"
                                          [icon]="'plus'"></wbo-secondary-button>
                    <wbo-ok-button *ngIf="!hideSaveAction"
                                   (click)="save()"
                                   [title]="saveLabel"
                                   [disabled]="disableSave"></wbo-ok-button>
                    <ng-content select="wbo-edit-page-footer-buttons"></ng-content>
                </ng-container>
                <ng-container *ngSwitchCase="true">
                    <wbo-cancel-button (click)="cancel()" *ngIf="!hideCancelAction" [title]="'wbo.common.button.close'"></wbo-cancel-button>
                </ng-container>
                <wbo-messaging-footer-button
                    *ngIf="customerSupportMessagingService.isDisplayed() && !isStackedPageMode"></wbo-messaging-footer-button>
            </fui-buttons>
        </ng-template>
    </fui-page-footer>
</fui-page>

